import Field from '../Field'
import toFinite from 'lodash/toFinite'

export default class extends Field {
  static name = 'number'

  mutator (value) {
    return toFinite(value)
  }
}
